<template>
  <div class="big-container">
    <div class="container">
      <header class="header">
        <img src="https://encaucetotal.com/wp-content/uploads/2021/03/planeta-encauce-300x300.png" alt="Encauce Logo" class="logo" />
        <h1 class="heading">Carrito de Compras</h1>
      </header>
      <div class="woocommerce">
        <div class="woocommerce-notices-wrapper"></div>
        <form class="woocommerce-cart-form" @submit.prevent="updateCart">
          <table class="shop_table shop_table_responsive cart woocommerce-cart-form__contents table" cellspacing="0">
            <thead>
              <tr>
                <th class="product-remove">&nbsp;</th>
                <th class="product-thumbnail">&nbsp;</th>
                <th class="product-name">Producto</th>
                <th class="product-price">Precio</th>
                <th class="product-quantity">Cantidad</th>
                <th class="product-subtotal">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in cartItems" :key="item.id" class="woocommerce-cart-form__cart-item cart_item">
                <td class="product-remove">
                  <a href="#" class="remove" @click.prevent="removeItem(item.id)" aria-label="Borrar este artículo">&times;</a>
                </td>
                <td class="product-thumbnail">
                  <a :href="item.url"><img :src="item.image" class="img-fluid" alt="Producto" /></a>
                </td>
                <td class="product-name">
                  <a :href="item.url">{{ item.name }}</a>
                </td>
                <td class="product-price">
                  <span class="amount"><bdi>{{ formatCurrency(item.price) }}</bdi></span>
                </td>
                <td class="product-quantity">
                  <div class="quantity">
                    <input
                      type="number"
                      :id="'quantity_' + item.id"
                      class="input-text qty text"
                      step="1"
                      min="1"
                      max="5000"
                      v-model.number="item.quantity"
                      @input="validateQuantity(item)"
                      title="Cantidad"
                      size="4"
                      placeholder=""
                      inputmode="numeric"
                    />
                  </div>
                </td>
                <td class="product-subtotal">
                  <span class="woocommerce-Price-amount amount"><bdi>{{ formatCurrency(item.price * item.quantity) }}</bdi></span>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
 
 
        <div class="cart-collaterals">
          <div class="cart_totals">
            <h2>Total del carrito</h2>
            <table cellspacing="0" class="shop_table shop_table_responsive table">
              <tr class="cart-subtotal">
                <th>Subtotal</th>
                <td>{{ formatCurrency(cartSubtotal) }}</td>
              </tr>
              <tr class="order-total">
                <th>Total</th>
                <td><span class="order-total-text">{{ formatCurrency(cartTotal) }}</span></td>
              </tr>
            </table>
            <div class="wc-proceed-to-checkout">
              <stripe-checkout
                ref="checkoutRef"
                :pk="stripePublicKey"
                :session-id="sessionId"
              />
              <button type="button" class="btn btn-success" @click="submit">Proceder con el Pago</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 </template>
 
 
 <script>
 import { StripeCheckout } from '@vue-stripe/vue-stripe';
 import axios from 'axios';
 
 
 export default {
  components: {
    StripeCheckout,
  },
  data() {
    return {
      cartItems: [
        {
          id: this.generateId(),
          name: "Encauce Total",
          price: 25,
          quantity: 1,
          url: "https://encaucetotal.com/producto/encauce-total/",
          image: "https://encaucetotal.com/wp-content/uploads/2021/03/planeta-encauce-300x300.png"
        }
      ],
      stripePublicKey: "pk_test_51PaLSwGqogu1n0BxkyfNuiSqyBB6Vb6CN6hC8af1BnJAGDl7An69DBGsQ0IzpgwiipmNTunQesF7UcB6JR1rPig200udgNyOg5",
      cancelUrl: "https://tusitio.com/cancel",
      loading: false,
      sessionId: "your-session-id", // session id from backend
    };
  },
  async mounted() {
 //    this.sessionId = await this.createCheckoutSession();
  },
  computed: {
    cartSubtotal() {
      return this.cartItems.reduce((total, item) => total + (item.price * item.quantity || 0), 0);
    },
    cartTotal() {
      return this.cartSubtotal; // Add other costs like taxes or shipping if needed
    },
    stripeItems() {
      return this.cartItems.map(item => ({
        price_data: {
          currency: 'usd',
          product_data: {
            name: item.name,
          },
          unit_amount: item.price * 100,
        },
        quantity: item.quantity,
      }));
    }
  },
  methods: {
    updateCart() {
      return this.cartItems.map(item => ({
        price_data: {
          currency: 'usd',
          product_data: {
            name: item.name,
          },
          unit_amount: item.price * 100,
        },
        quantity: item.quantity,
      }));
    },
    removeItem(itemId) {
      this.cartItems = this.cartItems.filter(item => item.id !== itemId);
    },
    applyCoupon() {
      // Logic to apply the coupon
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "USD"
      }).format(value);
    },
    validateQuantity(item) {
      if (item.quantity > 5000) {
        item.quantity = 5000;
      } else if (item.quantity < 1) {
        item.quantity = 1;
      }
    },
    async createCheckoutSession() {     
      const response = await axios.post('http://localhost:3001/api/encauce-zwippe/payment-button/create-checkout-session', { items: this.cartItems });
      return response.data.sessionId;
    },
    async submit() {
      this.$router.push({
        path: '/payment',
        query: {
          quantity: this.cartItems[0].quantity.toString(),
          total: this.cartTotal.toString(),
          unitPrice: this.cartItems[0].price.toString()
        }
      });
    },
    generateId() {
      return '_' + Math.random().toString(36).substr(2, 9);
    }
  }
 };
 </script>
 
 
 
 
 <style scoped>
 /* Estilos existentes */
 .container {
  width: 100vh;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
  color: #fff;
 }
 .header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 49px;
  background-color: transparent;
 }
 .logo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
 }
 .heading {
  font-size: 0.9em; /* 20px */
  color: #fff;
  margin: 0;
 }
 .woocommerce .shop_table {
  width: 100%;
  margin-bottom: 20px;
  border-collapse: collapse;
 }
 .woocommerce .shop_table th,
 .woocommerce .shop_table td {
  padding: 12px;
  border: 1px solid transparent;
  text-align: left;
 }
 .woocommerce .shop_table th {
  background-color: #1c202e;
  color: #fff;
  font-size: 0.5em; /* 16px */
 }
 .woocommerce .shop_table td {
  background-color: #fff;
  color: #333;
  font-size: 0.6em; /* 14px */
 }
 .woocommerce .product-remove .remove {
  color: #d9534f;
  font-size: 2em; /* 19.2px */
  text-decoration: none;
 }
 .woocommerce .product-thumbnail img {
  max-width: 70px;
  border-radius: 4px;
 }
 .woocommerce .product-name a {
  color: #0056b3;
  text-decoration: none;
  font-size: 0.8em; /* 14px */
 }
 .woocommerce .product-quantity input {
  width: 100px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 0.6em; /* 14px */
  color: black;
 }
 .actions {
  text-align: right;
 }
 .coupon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
 }
 .coupon input {
  flex: 1;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  margin-right: 10px;
  font-size: 0.45em; /* 14px */
  color: rgb(19, 23, 32);
 }
 .coupon button {
  padding: 10px 20px;
  font-size: 0.45em; /* 14px */
 }
 .cart_totals {
  margin-top: 30px;
  background-color: #1a1b1e;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
 }
 .cart_totals h2 {
  margin-bottom: 20px;
  font-size: 0.88em; /* 20px */
  color: #fff;
 }
 .cart_totals table {
  width: 100%;
  border-collapse: collapse;
 }
 .cart_totals th,
 .cart_totals td {
  padding: 10px;
  border: 1px solid #ddd;
  font-size: 0.875em; /* 14px */
 }
 .cart_totals th {
  background-color: #ddd;
  color: #fff;
 }
 .cart_totals td {
  background-color: #fff;
  color: #333;
  text-align: right;
 }
 .wc-proceed-to-checkout .btn {
  display: block;
  width: 100%;
  text-align: center;
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 0.5em; /* 14px */
  padding: 10px;
  transition: background-color 0.3s ease;
 }
 .wc-proceed-to-checkout .btn:hover {
  background-color: #218838;
 }
 .big-container {
  background: linear-gradient(45deg,#22113d,#2f355e);
  height: 100vh;
 }
 .amount bdi {
  font-size: 0.6em;
 }
 .product-price {
  background-color: green;
 }
 .coupon_code{
  margin-right: 6px;
 }
 .order-total-text {
  font-size: 1em;
 }
 </style>
 